import React from 'react';
import { MultiSelectWidget } from './MultiSelectWidget';
import type { ChatWidgetProps } from '../../types/widgets';
import type { ApiSelectWidget, ApiMultiSelectWidget } from '../../types/api';

/**
 * SelectWidget — single-select group form delivered via SSE widget events.
 * The data shape is identical to ApiMultiSelectWidget; this wrapper maps
 * the 'select' widget_type to the shared MultiSelectWidget renderer.
 */
export const SelectWidget: React.FC<ChatWidgetProps<ApiSelectWidget>> = (props) => {
  return <MultiSelectWidget {...(props as unknown as ChatWidgetProps<ApiMultiSelectWidget>)} />;
};
